import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Flex,
  useScreenResolution,
  ModalContext,
  Select,
  FilterContext,
} from 'dash-ui';

import FilterByAlerts from './compoonents/FilterByAlerts/FilterByAlerts';
import {
  ButtonContainer,
  SelectContainer,
} from './compoonents/FilterByAlerts/FilterByAlerts.styles';
import { FlexWraper } from 'containers/alerts/AllAlertsPropertiesContainer/components/AlertsTopBar/AlertsTopBar.styles';
import {
  ALERT_ITEMS_SORT_VALUES,
  AlertItemsSortOptionsEnum,
} from './AlertsTopBar.constants';

const AlertsTopBar = () => {
  const { t } = useTranslation('pages');
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const { setFilterState } = useContext(FilterContext);
  const { toggleModal } = useContext(ModalContext);

  return (
    <FlexWraper mt={[4, 6, 10, 10]} justifyContent="flex-end" w="100%">
      <Flex
        minWidth={['100%', 161, 161, 161]}
        maxWidth={['unset', 160, 160, 240]}
        mb={2}
      >
        <FilterByAlerts />
      </Flex>
      <Flex
        minWidth={['100%', 161, 161, 161]}
        maxWidth={['unset', 160, 160, 240]}
        mb={2}
        ml={[0, 2, 2, 2]}
      >
        <Select
          w="100%"
          isSearchable={false}
          placeholder={t('common:labels:sortBy')}
          onChanged={(value) =>
            setFilterState(
              'sort',
              ALERT_ITEMS_SORT_VALUES[value] || {
                fieldName: 'brokerAlertConfig.name',
                sortOrder: 1,
              }
            )
          }
          options={Object.values(AlertItemsSortOptionsEnum).map((item) => ({
            label: t(`common:sortOptions.${item}`),
            value: item,
          }))}
          components={
            isMobile
              ? {
                  SelectContainer: ({ children }) => {
                    return (
                      <Flex>
                        <ButtonContainer>
                          <Button
                            square
                            icon="filterList"
                            variation="outline"
                          />
                        </ButtonContainer>
                        <SelectContainer w="100%">{children}</SelectContainer>
                      </Flex>
                    );
                  },
                }
              : {}
          }
        />
      </Flex>
      <Flex w={['100%', 0, 0, 0]} justifyContent="center">
        <Flex ml={[0, 2, 2, 2]}>
          <Button
            px={[2, 3, 10, 10]}
            icon="plus"
            onClick={() => toggleModal(true, 'AddAlertModal')}
          >
            {t('pages:alertPage:labels:addAlert')}
          </Button>
        </Flex>
        <Flex ml={4}>
          <Button
            px={[2, 3, 10, 10]}
            variation="outline"
            onClick={() => toggleModal(true, 'AlertListModal')}
          >
            {t('pages:alertPage:labels:manageAlerts')}
          </Button>
        </Flex>
      </Flex>
    </FlexWraper>
  );
};

export default AlertsTopBar;
